import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  HostBinding,
  Input,
  OnInit,
  TemplateRef,
  output,
  ContentChildren,
  QueryList
} from '@angular/core';
import {
  ITabPanelHeader,
  TabViewHeaderSize
} from './m-tab-view.component.types';
import {
  Tabs,
  TabsStyle,
  TabList,
  Tab,
  TabPanels,
  TabPanel
} from 'primeng/tabs';
import { MTabIndexDirective } from './m-tab-index.directive';
import { Ripple } from 'primeng/ripple';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-tab-view',
  templateUrl: './m-tab-view.component.html',
  styleUrls: ['./m-tab-view.component.scss'],
  providers: [
    TabsStyle,
    { provide: Tabs, useExisting: forwardRef(() => MTabViewComponent) }
  ],
  imports: [
    TabList,
    Ripple,
    Tab,
    NgClass,
    TabPanels,
    TabPanel,
    NgTemplateOutlet
  ]
})
export class MTabViewComponent extends Tabs implements OnInit {
  @Input() headerSize: TabViewHeaderSize = TabViewHeaderSize.default;
  @Input() tabPanelHeaders: ITabPanelHeader[] = [];
  @Input() showDivider = false;

  @ContentChildren(MTabIndexDirective)
  tabDirectives!: QueryList<MTabIndexDirective>;

  @Input()
  set activeIndex(val: number) {
    this.value.set(val);
  }

  get activeIndex(): number {
    // eslint-disable-next-line no-constant-binary-expression
    return Number(this.value()) ?? 0;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.value() == null) {
      this.value.set(0);
    }
  }

  readonly activeIndexChange = output<number>();

  @HostBinding('class.tabs-with-divider')
  get hasDivider(): boolean {
    return this.showDivider && this.tabPanelHeaders.length > 1;
  }

  onValueChange(newValue: string | number): void {
    const index = Number(newValue);
    this.value.set(index);
    this.activeIndexChange.emit(index);
  }

  get tabTemplates(): TemplateRef<unknown>[] {
    return this.tabDirectives?.map((d) => d.templateRef) ?? [];
  }
}
